// Configuración para manejo de URLs de imágenes

export const getFullImageUrl = (imagePath: string): string => {
  // Si no hay path, devolver string vacío
  if (!imagePath) {
    return '';
  }

  // Si el path ya es una URL completa, devolverla tal cual
  if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
    return imagePath;
  }

  const host = window.location.hostname;
  const protocol = window.location.protocol;

  // En desarrollo local
  if (host === 'localhost' || host === '127.0.0.1') {
    return `http://localhost:5000${imagePath}`;
  }

  // En producción con HTTPS, usar la ruta API proxy
  if (protocol === 'https:' && (host === 'www.efectofm.es' || host === 'efectofm.es')) {
    // Convertir rutas de /parrilla/* a /api/images/parrilla/*
    if (imagePath.startsWith('/parrilla/')) {
      return `/api/images${imagePath}`;
    }
    // Convertir rutas de /uploads/* a /api/images/uploads/*
    if (imagePath.startsWith('/uploads/')) {
      return `/api/images${imagePath}`;
    }
    // Por defecto, agregar /api/images
    return `/api/images${imagePath}`;
  }

  // Para otros casos HTTP, usar el servidor directamente
  return `http://${host}:5000${imagePath}`;
};